import { render } from "./UrlParamsBlock.vue?vue&type=template&id=6cb3996e"
import script from "./UrlParamsBlock.vue?vue&type=script&lang=js"
export * from "./UrlParamsBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/UrlParamsBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cb3996e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cb3996e', __exports__)) {
    api.reload('6cb3996e', __exports__)
  }
  
  module.hot.accept("./UrlParamsBlock.vue?vue&type=template&id=6cb3996e", () => {
    api.rerender('6cb3996e', render)
  })

}


export default __exports__